import React, { useContext } from "react";

import Link from "next/link";
import { useRouter } from "next/router";

import * as Breadcrumbs from "~/components/Breadcrumbs";
import { ArrowLeftIcon } from "~/components/icons/Arrow";
import { BackButtonContext } from "~/contexts/BackButtonContext/BackButtonContext";
import {
  DASHBOARD_DIRECTORY_BASEPATH,
  PUBLIC_DIRECTORY_BASEPATH,
} from "~/contexts/BackButtonContext/BackButtonContext";
import { VASP } from "~/types/vaspid";

interface Props {
  vasp: VASP | undefined;
}

export default function VaspBackButton(_props: Props) {
  const { searchParamsStr } = useContext(BackButtonContext);
  const router = useRouter();

  const basePath = router.pathname.includes("dashboard") ? DASHBOARD_DIRECTORY_BASEPATH : PUBLIC_DIRECTORY_BASEPATH;
  const backUrl = `${basePath}${searchParamsStr}`;

  return (
    <Breadcrumbs.Container>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Breadcrumbs.Item>
          <Link href={backUrl} passHref>
            <Breadcrumbs.ItemContent>
              <Breadcrumbs.ItemContentIcon>
                <ArrowLeftIcon />
              </Breadcrumbs.ItemContentIcon>
              <Breadcrumbs.ItemContentText>Back</Breadcrumbs.ItemContentText>
            </Breadcrumbs.ItemContent>
          </Link>
        </Breadcrumbs.Item>
      </div>
    </Breadcrumbs.Container>
  );
}
